import { createClient } from 'graphql-ws';

if (!window.wsClient) {
  let firstConnected = false;
  window.wsClient = createClient({
    url: process.env.VUE_APP_GRAPHQL2_URL,
    keepAlive: 5000,
    retryAttempts: Infinity,
    // retryWait: count => count * 1000,
    // shouldRetry: () => true,
    on: {
      connected: () => {
        console.log('connected');

        if (!firstConnected) {
          firstConnected = true;
        }

        document.querySelector('#disconnected')?.remove();
      },
      closed: () => {
        console.log('disconnected');

        if (location.pathname !== '/login') {
          if (!document.querySelector('#disconnected')) {
            const disconnected = document.createElement('div');
            disconnected.id = 'disconnected';
            disconnected.innerHTML = 'Disconnected from server';
            window.document.body.appendChild(disconnected);
          }
        }
      },
      error: error => console.error(error),
    },
  });
}

export const wsClient = window.wsClient;
